// extracted by mini-css-extract-plugin
export default {"wrapper":"Main_wrapper__ZHMhH","inner":"Main_inner__ahb6J","sidebar":"Main_sidebar__+11vF","content":"Main_content__K-UKn"};